module.exports = __webpack_public_path__ + "static/media/twitter.23213ee5.svg";